import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Navbar from "./MainNavbar";
import { GetYear } from "../utils/GetYear";
import Breadcrumb from "../utils/Breadcrumb";
import BadgeCheck from "../assets/icons/BadgeCheck";

function MainLayout({ children, progress = false, dashboard = false }) {
  const location = useLocation();
  let pathFile = location.pathname;
  const [labelFile, setLabelFile] = useState("Standard");

  let LinkItem = [
    {
      label: "Standard",
      link: "/main/standard",
    },
    {
      label: "Dashboard",
      link: "/main/dashboard",
    },
    {
      label: "Progress",
      link: "/main/progress",
    },
  ];

  useEffect(() => {
    if (location.pathname == `/main/standard`) {
      setLabelFile("Standard");
    } else if (location.pathname == `/main/dashboard`) {
      setLabelFile("Dashboard");
    } else if (location.pathname == `/main/progress`) {
      setLabelFile("Progress");
    }
  }, [location.pathname]);

  return (
    <div className=" w-full h-full overflow-hidden">
      <div className=" w-full h-[60px]">
        <Navbar />
      </div>
      <div className="w-[100%] h-[calc(100vh-80px)]">
        <div className=" w-[92%] h-full mx-auto">
          <Breadcrumb
            items={[
              {
                name: labelFile,
              },
            ]}
          />
          <div className=" w-full h-11 flex  gap-x-9 items-center">
            <div className=" h-11 flex items-center gap-x-1   z-0">
              {LinkItem &&
                LinkItem.map((item, i) => {
                  return (
                    <React.Fragment key={i}>
                      {
                        <Link
                          to={item?.link}
                          className={`mx-1  px-1 text-base 2xl:text-lg font-normal text-baseColor-primary ${
                            item?.link == pathFile
                              ? " rounded-t bg-gray-200 border-b-4 border-primary text-gray-600"
                              : "border-b-4 border-transparent text-gray-400"
                          }   `}
                          key={i}
                          onClick={() => {
                            setLabelFile(item?.label);
                            console.log(item?.label);
                          }}
                        >
                          {item?.label || ""}
                        </Link>
                      }
                    </React.Fragment>
                  );
                })}
            </div>
            {progress && (
              <div className=" px-2 relative z-10">
                <div className=" flex items-center">
                  <div>
                    <p
                      title=""
                      className=" flex items-center text-[11px] px-[10px] py-2  text-[#FF0000] "
                    >
                      <span className=" w-[10px] h-[10px] rounded-full bg-[#FF0000] mx-2"></span>
                      Yet To Start
                    </p>
                  </div>
                  <div>
                    <p
                      title=""
                      className=" flex items-center text-[11px] px-[10px] py-2  text-[#ffd700] "
                    >
                      <span className=" w-[10px] h-[10px] rounded-full bg-[#ffd700] mx-2"></span>
                      In Progress
                    </p>
                  </div>
                  <div>
                    <p
                      title=""
                      className=" flex items-center text-[11px] px-[10px] py-2  text-[#008000] "
                    >
                      <span className=" w-[10px] h-[10px] rounded-full bg-[#008000] mx-2"></span>
                      Completed
                    </p>
                  </div>
                  <div>
                    <p
                      title=""
                      className=" flex items-center text-[11px] px-[10px] py-2  text-[#7030A0] "
                    >
                      <span className=" mx-2">
                        <BadgeCheck width="w-[13px]" height="h-[13px]" />
                      </span>
                      Reviewed & Approved
                    </p>
                  </div>
                </div>
              </div>
            )}

            {dashboard && (
              <div className=" px-2 relative z-10">
                <div className=" xl:flex items-center">
                  <div className=" flex items-center">
                    <div>
                      <p
                        title=""
                        className=" flex items-center text-[11px] px-[10px] py-2  text-[#FF0000] "
                      >
                        <span className=" w-[10px] h-[10px] rounded-full bg-[#FF0000] mx-2"></span>
                        Yet To Start
                      </p>
                    </div>
                    <div>
                      <p
                        title=""
                        className=" flex items-center text-[11px] px-[10px] py-2  text-[#ffd700] "
                      >
                        <span className=" w-[10px] h-[10px] rounded-full bg-[#ffd700] mx-2"></span>
                        In Progress
                      </p>
                    </div>
                    <div>
                      <p
                        title=""
                        className=" flex items-center text-[11px] px-[10px] py-2  text-[#008000] "
                      >
                        <span className=" w-[10px] h-[10px] rounded-full bg-[#008000] mx-2"></span>
                        Completed
                      </p>
                    </div>
                  </div>
                  <p className="text-[11px] text-left text-gray-500">
                    (Drill Down functionality will work from Standard Dashboard
                    and Progress page only)
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="w-[100%] h-[calc(100vh-145px)] p-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-lg overflow-y-auto z-[3]">
            {children}
          </div>
        </div>
      </div>
      <div className=" w-full h-5 ">
        <p className=" text-slate-400 text-center w-full text-xs">
          <span className=" text-[15px] font-medium">&copy;</span> {GetYear()}{" "}
          <a href="https://www.metatroninfotech.com/" target="_blank">Metatron Infotech.</a> 
        </p>
      </div>
    </div>
  );
}

export default MainLayout;
